import { Tooltip, Typography } from '@material-ui/core'
import { useState } from 'react'

import { gregorianToJalaaliWithHourMinuteAndSecond } from '../../../helpers/date'
import { lang } from '../../../localization'
import { ComLog } from '../../../types/monitoring'
import { redactSecrets } from '../../../utils/comlogRedaction'
import MonitoringFormViewMoreInfoModal from '../MonitoringFormViewMoreInfoModal'
import MonitoringRowMenu from '../MonitoringRowMenu'
import useStyles from './styles/MonitoringFormListRow.styles'

interface MonitoringFormListRowDesktopProps {
  data: ComLog
}
/**
 * PMS integrations authenticate inside the message body — a Mosafer request
 * carries the property's SecurityPass and each channel's AgencyPass in
 * cleartext — so the raw payload is masked before it is shown. This screen
 * predates the redaction; it was exposing those values, and is fixed here
 * rather than left as the unredacted path beside a redacted one.
 */
const MonitoringFormListRowDesktop: React.FC<
  MonitoringFormListRowDesktopProps
> = ({ data }) => {
  const classes = useStyles()
  const [viewRequestIsOpen, setviewRequestIsOpen] = useState<boolean>(false)
  const [viewResponseIsopen, setviewResponseIsopen] = useState<boolean>(false)
  return (
    <div className={classes.root}>
      <div>
        <Typography variant="body1">
          {lang === 'fa'
            ? gregorianToJalaaliWithHourMinuteAndSecond(data.Date)
            : data.Date}
        </Typography>
      </div>
      <div>
        <Typography variant="body1">{data.UserIP}</Typography>
      </div>
      <div>
        <Typography variant="body1">
          {JSON.parse(redactSecrets(data.Request)).Method}
        </Typography>
      </div>
      <div>
        <Typography variant="body1">
          {data.EndpointName.length < 25
            ? data.EndpointName
            : `${data.EndpointName.substr(0, 25)} ...`}
        </Typography>
      </div>
      <div>
        <Tooltip title={data.EndpointURL} placement="top-start">
          <Typography variant="body1" noWrap>
            {data.EndpointURL.length < 25
              ? data.EndpointURL
              : `${data.EndpointURL.substr(0, 25)} ...`}
          </Typography>
        </Tooltip>
      </div>
      <div>
        <Typography variant="body1">{data.Status}</Typography>
      </div>
      <div className={classes.moreIcon}>
        <MonitoringRowMenu
          viewRequest={() => setviewRequestIsOpen(true)}
          viewResponse={() => setviewResponseIsopen(true)}
        />
      </div>
      <MonitoringFormViewMoreInfoModal
        requestView={JSON.parse(redactSecrets(data.Request))}
        isOpen={viewRequestIsOpen}
        onClose={() => setviewRequestIsOpen(false)}
      />
      <MonitoringFormViewMoreInfoModal
        requestView={JSON.parse(redactSecrets(data.Response))}
        isOpen={viewResponseIsopen}
        onClose={() => setviewResponseIsopen(false)}
      />
    </div>
  )
}
export default MonitoringFormListRowDesktop
